<template>
    <div class="Table">
        <div class="Table-content">
            <div class="Table-content-wrap" :class="{'fixed-first-column': isFixedFirstColumn,'fixed-first-second-column': isFixedFirstColumn && hasCheckbox,}">
                <div v-if="isLoading" class="Table-content-loading">
                    <Loader />
                    Processing...
                </div>
                <table ref="localTable">
                    <thead>
                        <tr>
                            <th v-if="hasCheckbox" class="Table-header-checkbox">
                                <div>
                                    <input type="checkbox" class="vtl-thead-checkbox" v-model="setting.isCheckAll"/>
                                </div>
                            </th>
                            <th v-for="( col, index ) in columns" class="Table-header-label" :class="col.headerClasses" :colspan="col.headerColspan" :rowspan="col.headerRowspan" :key="index" :style="Object.assign({ width: col.width ? col.width : 'auto' }, col.headerStyles )">
                                <div :class="{'sortable': col.sortable }" @click="col.sortable ? doSort(col.field) : false">
                                    {{ col.label }}
                                    <div v-if="col.sortable">
                                        <i :class="{'fa-solid fa-sort': col.sortable }"></i>
                                        <i :class="{'fa-solid fa-sort-up': setting.order === col.field && setting.sort === 'asc', 'fa-solid fa-sort-down': setting.order === col.field && setting.sort === 'desc' }"></i>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="rows.length > 0">
                    <tr v-for="(row, i) in ( isStaticMode? localRows : rows )" :key="i" :class="typeof rowClasses === 'function' ? rowClasses(row) : rowClasses" @click="$emit('row-clicked', row)">
                        <td v-if="hasCheckbox" class="Table-body-checkbox">
                            <div>
                                <input type="checkbox" class="vtl-tbody-checkbox" :ref="(el) => { rowCheckbox[i] = el; }" :value="row[setting.keyColumn]" @click="checked"/>
                            </div>
                        </td>
                        <td v-for="(col, j) in columns" :key="j" class="Table-body-label" :class="col.columnClasses" :colspan="col.columnColspan" :rowspan="col.columnRowspan" :style="col.columnStyles">
                            <div v-if="col.display" v-html="col.display(row)"></div>
                            <template v-else>
                                <div v-if="setting.isSlotMode && slots[col.field]">
                                    <slot :name="col.field" :value="row"></slot>
                                </div>
                                <span v-else>{{ row[col.field] }}</span>
                            </template>
                        </td>
                    </tr>
                    <!--
                    <template v-if="isStaticMode">
                        <tr v-for="(row, i) in localRows" :key="i" :class="typeof rowClasses === 'function' ? rowClasses(row) : rowClasses" @click="$emit('row-clicked', row)">
                            <td v-if="hasCheckbox" class="Table-body-checkbox">
                                <div>
                                    <input type="checkbox" class="vtl-tbody-checkbox" :ref="(el) => { rowCheckbox[i] = el; }" :value="row[setting.keyColumn]" @click="checked"/>
                                </div>
                            </td>
                            <td v-for="(col, j) in columns" :key="j" class="Table-body-label" :class="col.columnClasses" :style="col.columnStyles">
                                <div v-if="col.display" v-html="col.display(row)"></div>
                                <template v-else>
                                    <div v-if="setting.isSlotMode && slots[col.field]">
                                        <slot :name="col.field" :value="row"></slot>
                                    </div>
                                    <span v-else>{{ row[col.field] }}</span>
                                </template>
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr v-for="(row, i) in rows" :key="i" :class="typeof rowClasses === 'function' ? rowClasses(row) : rowClasses" @click="$emit('row-clicked', row)">
                            <td v-if="hasCheckbox" class="Table-body-checkbox">
                                <div>
                                    <input type="checkbox" class="vtl-tbody-checkbox" :ref="(el) => { rowCheckbox[i] = el; }" :value="row[setting.keyColumn]" @click="checked"/>
                                </div>
                            </td>
                            <td v-for="(col, j) in columns" :key="j" class="Table-body-label" :class="col.columnClasses" :style="col.columnStyles">
                                <div v-if="col.display" v-html="col.display(row)"></div>
                                <div v-else>
                                    <div v-if="setting.isSlotMode && slots[col.field]">
                                        <slot :name="col.field" :value="row"></slot>
                                    </div>
                                    <span v-else>{{ row[col.field] }}</span>
                                </div>
                            </td>
                        </tr>
                    </template>
                    -->
                    </tbody>
                </table>
            </div>
        </div>
        <div class="Table-pagination" v-if="rows.length > 0">
            <template v-if="!setting.isHidePaging">
                <div class="Table-pagination-info" role="status" aria-live="polite" v-html="stringFormat(messages.pagingInfo, setting.offset, setting.limit, total)"></div>
                <div class="Table-pagination-button-group">
                    <ul>
                        <li>
                            <a :class="{ 'disabled': setting.page <= 1 }" href="javascript:void(0)" aria-label="Previous" @click="setting.page = 1">
                                    <span aria-hidden="true">
                                        <i class="fa-regular fa-chevrons-left"></i>
                                    </span>
                                <span class="sr-only">First</span>
                            </a>
                        </li>
                        <li>
                            <a :class="{ 'disabled': setting.page <= 1 }" href="javascript:void(0)" aria-label="Previous" @click="prevPage">
                                    <span aria-hidden="true">
                                        <i class="fa-regular fa-chevron-left"></i>
                                    </span>
                                <span class="sr-only">Prev</span>
                            </a>
                        </li>
                        <li v-for="n in setting.paging" :key="n">
                            <a :class="{ 'active': setting.page === n }" href="javascript:void(0)" @click="movePage(n)">{{ n }}</a>
                        </li>
                        <li>
                            <a :class="{ 'disabled': setting.page >= setting.maxPage }" href="javascript:void(0)" aria-label="Next" @click="nextPage">
                                    <span aria-hidden="true">
                                        <i class="fa-regular fa-chevron-right"></i>
                                    </span>
                                <span class="sr-only">Next</span>
                            </a>
                        </li>
                        <li>
                            <a :class="{ 'disabled': setting.page >= setting.maxPage }" href="javascript:void(0)" aria-label="Next" @click="setting.page = setting.maxPage">
                                    <span aria-hidden="true">
                                        <i class="fa-regular fa-chevrons-right"></i>
                                    </span>
                                <span class="sr-only">Last</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <!--

                TOTO JE SELECT NA CURRENT PAGE A ITEMS PER PAGE

                <div class="Table-pagination-setting">
                    <Label :title="messages.pageSizeChangeLabel">
                        <select v-model="setting.pageSize">
                            <option v-for="pageOption in pageOptions" :value="pageOption.value" :key="pageOption.value">
                                {{ pageOption.text }}
                            </option>
                        </select>
                    </Label>
                    <Label :title="messages.gotoPageLabel">
                        <select v-model="setting.page">
                            <option v-for="n in setting.maxPage" :key="n" :value="parseInt(n)">
                                {{ n }}
                            </option>
                        </select>
                    </Label>
                </div>
                -->
            </template>
        </div>
        <div class="Table-empty" v-else>
            <div class="Table-empty-message">{{ messages.noDataAvailable }}</div>
        </div>
    </div>
</template>

<script>
import { defineComponent, ref, reactive, computed, watch, onBeforeUpdate, nextTick, onMounted } from "vue";

export default defineComponent(
    {
        name: "Table",
        emits:
            [
                "return-checked-rows",
                "do-search",
                "is-finished",
                "get-now-page",
                "row-clicked",
            ],
        props:
            {
                isLoading:
                    {
                        type: Boolean,
                        require: true,
                    },
                isReSearch:
                    {
                        type: Boolean,
                        require: true,
                    },
                hasCheckbox:
                    {
                        type: Boolean,
                        default: false,
                    },
                checkedReturnType:
                    {
                        type: String,
                        default: "key",
                    },
                isFixedFirstColumn:
                    {
                        type: Boolean,
                        default: false,
                    },
                columns:
                    {
                        type: Array,
                        default: () => { return []; },
                    },
                rows:
                    {
                        type: Array,
                        default: () => { return []; },
                    },
                rowClasses:
                    {
                        type: [Array, Function],
                        default: () => { return []; },
                    },
                pageSize:
                    {
                        type: Number,
                        default: 10,
                    },
                total:
                    {
                        type: Number,
                        default: 100,
                    },
                page:
                    {
                        type: Number,
                        default: 1,
                    },
                sortable:
                    {
                        type: Object,
                        default: () => { return { order: "id", sort: "asc" }; },
                    },
                messages:
                    {
                        type: Object,
                        default: () =>
                        {
                            return (
                                {
                                    pagingInfo: "Showing <b>{0}-{1}</b> of <b>{2}</b>",
                                    pageSizeChangeLabel: "Row count:",
                                    gotoPageLabel: "Go to page:",
                                    noDataAvailable: "No data",
                                });
                        },
                    },
                isStaticMode:
                    {
                        type: Boolean,
                        default: false,
                    },
                isSlotMode:
                    {
                        type: Boolean,
                        default: false,
                    },
                isHidePaging:
                    {
                        type: Boolean,
                        default: false,
                    },
                pageOptions:
                    {
                        type: Array,
                        default: () =>
                            [
                                {
                                    value: 10,
                                    text: 10,
                                },
                                {
                                    value: 25,
                                    text: 25,
                                },
                                {
                                    value: 50,
                                    text: 50,
                                },
                            ],
                    },
            },
        setup( props, { emit, slots } )
        {
            let localTable = ref(null);

            let defaultPageSize = props.pageOptions.length > 0 ? ref(props.pageOptions[0].value) : ref(props.pageSize);

            if (props.pageOptions.length > 0)
            {
                props.pageOptions.forEach((v) =>
                {
                    if ( Object.prototype.hasOwnProperty.call(v, "value") && Object.prototype.hasOwnProperty.call(v, "text") && props.pageSize == v.value)
                    {
                        defaultPageSize.value = v.value;
                    }
                });
            }

            const setting = reactive(
                {
                    isSlotMode          : props.isSlotMode,
                    isCheckAll          : false,
                    isHidePaging        : props.isHidePaging,
                    keyColumn           : computed(() =>
                    {
                        let key = "";

                        Object.assign(props.columns).forEach((col) => { if (col.isKey) { key = col.field; }});

                        return key;
                    }),
                    page: props.page,
                    pageSize: defaultPageSize.value,
                    maxPage: computed(() =>
                    {
                        if( props.total <= 0 ) { return 0; }

                        let maxPage = Math.floor(props.total / setting.pageSize);
                        let mod = props.total % setting.pageSize;
                        if (mod > 0) { maxPage++; }

                        return maxPage;
                    }),
                    offset: computed(() => { return (setting.page - 1) * setting.pageSize + 1; }),
                    limit: computed(() => { let limit = setting.page * setting.pageSize; return props.total >= limit ? limit : props.total; }),
                    paging: computed(() =>
                    {
                        let startPage = setting.page - 2 <= 0 ? 1 : setting.page - 2;
                        if( setting.maxPage - setting.page <= 2 ) { startPage = setting.maxPage - 4; }
                        startPage = startPage <= 0 ? 1 : startPage;
                        let pages = [];

                        for (let i = startPage; i <= setting.maxPage; i++)
                        {
                            if( pages.length < 5 ) { pages.push(i); }
                        }

                        return pages;
                    }),
                    order: props.sortable.order,
                    sort: props.sortable.sort,
                    pageOptions: props.pageOptions,
                });

            const localRows = computed(() =>
            {
                let rows = props.rows;
                // refs https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator/compare
                var collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base", });
                let sortOrder = setting.sort === "desc" ? -1 : 1;

                rows.sort(function (a, b) { return collator.compare(a[setting.order], b[setting.order]) * sortOrder; });

                let result = [];

                for (let index = setting.offset - 1; index < setting.limit; index++)
                {
                    if (rows[index]) { result.push(rows[index]); }
                }

                nextTick(function () { callIsFinished(); });

                return result;
            });

            ////////////////////////////
            //
            //  Checkbox
            //  (Checkbox related operations)
            //
            ////////////////////////////

            const rowCheckbox = ref([]);

            if( props.hasCheckbox )
            {
                onBeforeUpdate(() => { rowCheckbox.value = []; });

                watch(() => setting.isCheckAll, ( state ) =>
                {
                    let isChecked = [];

                    rowCheckbox.value.forEach(( val, i ) =>
                    {
                        if( val )
                        {
                            val.checked = state;

                            if( val.checked )
                            {
                                if( props.checkedReturnType === "row" )
                                {
                                    isChecked.push(localRows.value[i]);
                                }
                                else
                                {
                                    isChecked.push(val.value);
                                }
                            }
                        }
                    });

                    emit("return-checked-rows", isChecked);
                });
            }

            const checked = ( event ) =>
            {
                event.stopPropagation();

                let isChecked = [];

                rowCheckbox.value.forEach(( val, i ) =>
                {
                    if( val && val.checked )
                    {
                        if( props.checkedReturnType === "row" )
                        {
                            isChecked.push(localRows.value[i]);
                        }
                        else
                        {
                            isChecked.push(val.value);
                        }
                    }
                });

                emit("return-checked-rows", isChecked);
            };

            const clearChecked = () =>
            {
                rowCheckbox.value.forEach(( val ) =>
                {
                    if( val && val.checked ) { val.checked = false; }
                });

                emit("return-checked-rows", []);
            };

            ////////////////////////////
            //
            //
            //  (Sorting, page change, etc. related operations)
            //
            ////////////////////////////

            const doSort = (order) =>
            {
                let sort = "asc";

                if( order === setting.order )
                {
                    if (setting.sort === "asc") { sort = "desc"; }
                }

                let offset      = (setting.page - 1) * setting.pageSize;
                let limit       = setting.pageSize;
                setting.order   = order;
                setting.sort    = sort;

                emit("do-search", offset, limit, order, sort);

                if( setting.isCheckAll )
                {
                    setting.isCheckAll = false;
                }
                else
                {
                    if( props.hasCheckbox ) { clearChecked(); }
                }
            };

            const changePage = ( page, prevPage ) =>
            {
                setting.isCheckAll  = false;
                let order           = setting.order;
                let sort            = setting.sort;
                let offset          = (page - 1) * setting.pageSize;
                let limit           = setting.pageSize;

                if( !props.isReSearch || page > 1 || page === prevPage )
                {
                    emit("do-search", offset, limit, order, sort);
                }
            };

            watch(() => setting.page, changePage);

            watch(() => props.page, (val) =>
            {
                if( val <= 1 )
                {
                    setting.page = 1;
                    emit("get-now-page", setting.page);
                }
                else if( val >= setting.maxPage )
                {
                    setting.page = setting.maxPage;
                    emit("get-now-page", setting.page);
                }
                else
                {
                    setting.page = val;
                }
            });

            const changePageSize = () =>
            {
                if( setting.page === 1 )
                {
                    changePage(setting.page, setting.page);
                }
                else
                {
                    setting.page = 1;
                    setting.isCheckAll = false;
                }
            };

            watch(() => setting.pageSize, changePageSize);

            watch(() => props.pageSize, ( newPageSize ) =>
            {
                setting.pageSize = newPageSize;
            });

            const prevPage = () =>
            {
                if (setting.page === 1) { return false; }

                setting.page--;
            };

            const movePage = ( page ) =>
            {
                setting.page = page;
            };

            const nextPage = () =>
            {
                if (setting.page >= setting.maxPage) { return false; }

                setting.page++;
            };

            watch(() => props.rows, () =>
            {
                if (props.isReSearch || props.isStaticMode) { setting.page = 1; }

                nextTick(function ()
                {
                    if( !props.isStaticMode ) { callIsFinished(); }
                });
            });

            const stringFormat = (template, ...args) => { return template.replace(/{(\d+)}/g, function (match, number) { return typeof args[number] != "undefined" ? args[number] : match; }); };

            const callIsFinished = () =>
            {
                if( localTable.value )
                {
                    let localElement = localTable.value.getElementsByClassName("is-rows-el");

                    emit("is-finished", localElement);
                }

                emit("get-now-page", setting.page);
            };

            onMounted(() =>
            {
                nextTick(() =>
                {
                    if( props.rows.length > 0 ) { callIsFinished(); }
                });
            });

            if( props.hasCheckbox )
            {
                return { slots, localTable, localRows, setting, rowCheckbox, checked, doSort, prevPage, movePage, nextPage, stringFormat };
            }
            else
            {
                return { slots, localTable, localRows, setting, doSort, prevPage, movePage, nextPage, stringFormat };
            }
        },
    });
</script>

<style lang="scss">
.Table
{
    position: relative;

    display: flex;
    flex-direction: column;
    gap: px(8);

    min-width: 0;
    width: 100%;

    word-wrap: break-word;

    .Table-content
    {
        display: flex;
        flex-wrap: wrap;


        .Table-content-wrap
        {
            display: block;
            width: 100%;
            overflow-x: auto;

            .Table-content-loading
            {
                position: absolute;
                z-index: 9998;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;

                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: row;
                gap: px(8);

                background-color: rgba(255, 255, 255, 0.05);
                backdrop-filter: blur(#{px(4)});
            }

            table
            {
                width: 100%;
                border-collapse: collapse;

                tr
                {
                    display: table-row;

                    th, td
                    {
                        border-top: 1px solid var(--gray-3);

                        padding: 0 px(8);
                        margin: 0;
                    }
                }

                tr:last-child
                {
                    td
                    {
                        border-bottom: 1px solid var(--gray-3);
                    }
                }

                thead
                {
                    tr
                    {
                        th
                        {
                            height: px(32);
                            text-align: inherit;
                        }

                        th.Table-header-checkbox
                        {
                            width: 1%;
                        }

                        th.Table-header-label
                        {
                            @include font-s;
                            @include font-bold;
                            line-height: px(32);
                            color: var(--gray-6);
                            white-space: nowrap;

                            .sortable
                            {
                                position: relative;
                                display: inline-flex;
                                cursor: pointer;

                                > div
                                {
                                    position: absolute;
                                    top: 0;
                                    right: px(-12);

                                    i.fa-solid
                                    {
                                        @include font-xs;
                                        line-height: px(32);
                                        color: var(--gray-4);

                                        &.fa-sort-up, &.fa-sort-down
                                        {
                                            position: absolute;
                                            right: 0;
                                            left: 0;
                                            color: var(--gray-9);
                                        }

                                        &.fa-sort-up { top: 0; }
                                        &.fa-sort-down { bottom: 0; }
                                    }
                                }
                            }
                        }
                    }
                }

                tbody
                {
                    tr
                    {
                        td
                        {
                            height: px(40);
                            text-align: inherit;
                        }

                        td.Table-body-checkbox
                        {
                            width: 1%;
                        }

                        td.Table-body-label
                        {
                            @include font-m;
                            @include font-regular;
                            color: var(--gray-9);
                        }
                    }
                }
            }
        }
    }

    .Table-pagination
    {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        align-items: center;
        justify-content: space-between;

        .Table-pagination-info
        {
            @include font-m;
            @include font-thin;

            color: var(--gray-9);

            height: px(40);
            line-height: px(40);
        }

        .Table-pagination-button-group
        {
            display: flex;
            align-items: center;
            justify-self: flex-end;

            ul
            {
                display: flex;
                list-style: none;
                gap: px(4);

                li
                {
                    > a
                    {
                        position: relative;

                        display: flex;
                        align-items: center;
                        justify-content: center;

                        @include font-s;
                        @include font-regular;

                        color: var(--gray-6);

                        width: px(28);
                        height: px(28);
                        line-height: px(28);

                        border: 1px solid var(--gray-3);
                        border-radius: 50%;

                        &.active
                        {
                            -webkit-box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
                            box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);

                            background: #5e72e4;
                            color: white;
                        }

                        &.disabled
                        {
                            pointer-events: none;
                            color: var(--gray-3);
                        }

                        &:hover:not(.active):not(.disabled)
                        {
                            background: var(--gray-3);
                        }

                        .sr-only
                        {
                            position: absolute;
                            width: 1px;
                            height: 1px;
                            padding: 0;
                            margin: -1px;
                            overflow: hidden;
                            clip: rect(0, 0, 0, 0);
                            white-space: nowrap;
                            border: 0;
                        }
                    }
                }
            }
        }

        .Table-pagination-settings
        {
            display: flex;
            align-items: center;
            justify-self: flex-end;

            select
            {

            }
        }
    }

    .Table-empty
    {

        .Table-empty-message
        {

        }
    }
}
</style>